import { render, staticRenderFns } from "./GEChart.vue?vue&type=template&id=23657067&scoped=true&"
import script from "./GEChart.vue?vue&type=script&lang=js&"
export * from "./GEChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23657067",
  null
  
)

export default component.exports